import AppConfig from "~/config";

export default {

  computed: {
    production() { return (AppConfig.runtime.isProduction); },
  },

}